import hopeTheme from '../../../styles/themes/hopeTheme';

export const styles = {
  wineTitle: {
    cursor: 'pointer',
    color: 'white',
    marginLeft: 20,
  },
  giftTitle: {
    cursor: 'pointer',
    color: 'white',
    marginLeft: 5,
  },
  navContainer: {
    backgroundColor: hopeTheme.palette.navBarColor,
    paddingRight: 0,
    height: hopeTheme.navBar.height,
  },
  badgeStyle: {
    top: 27,
    cursor: 'pointer',
    backgroundColor: hopeTheme.brandSuccess,
  },
  hideBadge: {
    top: 27,
    right: 0,
    display: 'none',
  },
  // hideBadge: {
  //   top: 27,
  //   right: 18,
  //   WebkitAnimationDuration: '0.25s',
  //   animationDuration: '0.25s',
  //   WebkitAnimationFillMode: 'both',
  //   animationFillMode: 'both',
  //   WebkitAnimationName: 'quantityIconScaleOut',
  //   animationName: 'quantityIconScaleOut',
  //   animationTimingFunction: 'ease-in-out',
  // },
  badgePosition: {
    marginLeft: 0,
    marginTop: -15,
    marginBottom: 0,
    marginRight: 10,
  },
  find: {
    color: hopeTheme.textColor,
    fontFamily: hopeTheme.fontFamily,
    fontWeight: hopeTheme.weightBold,
    textTransform: 'uppercase',
    letterSpacing: '1.3px',
    fontSize: '16px',
    lineHeight: '14px',
    marginBottom: '-2px',
  },
  searchCloseIcon: {
    width: 46,
    height: 46,
    padding: 0,
    color: hopeTheme.hopeLightPurple,
  },
  searchClose: {
    padding: 0,
    marginTop: 15,
    marginLeft: -10,
  },
  searchIcon: {
    width: 30,
    height: 30,
    padding: 0,
  },
  search: {
    padding: 0,
  },
  mobileSearch: {
    padding: 0,
    marginTop: -2,
    marginRight: -10,
  },
  autoComplete: {
    style: {
      backgroundColor: 'white',
      height: '115px',
      color: 'black',
      width: '100%',
      boxShadow:
        '0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2)',
    },
    textFieldStyle: {
      color: 'black',
      paddingTop: 35,
      fontSize: 44,
      fontWeight: 400,
      width: '100%',
    },
    listStyle: {
      backgroundColor: '#f0f0f0',
      borderColor: '1px solid black',
    },
    menuStyle: {
      marginTop: 35,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      backgroundColor: '#f0f0f0',
      borderColor: '1px solid black',
    },
  },
  autoCompleteMobile: {
    style: {
      backgroundColor: 'white',
      height: '115px',
      color: 'black',
      width: '100%',
      boxShadow:
        '0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2)',
    },
    textFieldStyle: {
      color: 'black',
      paddingTop: 35,
      fontSize: 36,
      fontWeight: 400,
    },
    listStyle: {
      maxHeight: 150,
      overflow: 'auto',
      backgroundColor: '#f0f0f0',
      borderColor: '1px solid black',
    },
    menuStyle: {
      marginTop: 35,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      backgroundColor: '#f0f0f0',
      borderColor: '1px solid black',
    },
  },
  innerMenuStyleTop: {
    lineHeight: 1,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 20,
    marginTop: 10,
  },
  innerMenuStyle: {
    lineHeight: 1,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 20,
  },
  innerMenuStyleBottom: {
    lineHeight: 1,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 20,
    marginBottom: 10,
  },
};

export const listItemStyle = {
  WebkitAppearance: 'none',
  cursor: 'pointer',
};

export const buttonStyles = {
  color: hopeTheme.textColor,
  border: 'none',
  fontFamily: hopeTheme.headerMedium,
  fontWeight: 500 as 500,
  borderRadius: 'none',
  textTransform: 'none' as 'none',
  letterSpacing: 'normal',
  fontSize: '18px',
  lineHeight: '1.44',
  height: '44px',
  paddingLeft: '0px',
  paddingRight: '0px',
} as React.CSSProperties;

export const buttonFirstStyles = {
  fontFamily: hopeTheme.fontFamily,
  fontWeight: hopeTheme.weightBold,
  fontSize: '16px',
  letterSpacing: 'normal',
  border: 'none',
  textTransform: 'none',
  borderRadius: 'none',
  height: '60px',
  minWidth: '70px',
} as React.CSSProperties;

export const buttonFirstStylesWide = {
  fontFamily: hopeTheme.fontFamily,
  fontWeight: hopeTheme.weightBold,
  fontSize: '16px',
  letterSpacing: 1.3,
  border: 'none',
  textTransform: 'none',
  borderRadius: 'none',
  height: '60px',
  width: '200px',
} as React.CSSProperties;

export const buttonSelectedStyles = {
  fontFamily: hopeTheme.fontFamily,
  fontWeight: hopeTheme.weightBold,
  fontSize: '16px',
  letterSpacing: 1.3,
  border: 'none',
  textTransform: 'none',
  borderRadius: 'none',
  height: '60px',
  backgroundColor: 'white',
  color: hopeTheme.hopeLightPurple,
} as React.CSSProperties;
